import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { delay, filter, take, takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { RossConfigService } from 'src/@ross/services/config.service';
import { RossNavigationService } from 'src/@ross/components/navigation/navigation.service';
import { RossPerfectScrollbarDirective } from 'src/@ross/directives/ross-perfect-scrollbar/ross-perfect-scrollbar.directive';
import { RossSidebarService } from 'src/@ross/components/sidebar/sidebar.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { HttpClient } from '@angular/common/http';
import { ProfileImageService } from 'src/app/shared/services/profile-image-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ProfileImageDialogComponent } from '../../profile-image-dialog/profile-image-dialog.component';


@Component({
    selector     : 'navbar-vertical-style-1',
    templateUrl  : './style-1.component.html',
    styleUrls    : ['./style-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy {
    @ViewChild('fileInput') fileInput: any;
    rossConfig: any;
    navigation: any;
    currentUser: any;
    aptitud: number;
    profileImageUrl: string = 'assets/img/user.svg';
    userId: number | undefined;

    // Private
    private _rossPerfectScrollbar: RossPerfectScrollbarDirective;
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _rossConfigService: RossConfigService,
        private _rossNavigationService: RossNavigationService,
        private _rossSidebarService: RossSidebarService,
        private _authService: AuthenticationService,
        private _router: Router,
        private http: HttpClient,
        private dialog: MatDialog,
        private profileImageService: ProfileImageService
      ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.currentUser = this._authService.currentUserValue;
        this.aptitud = this.currentUser.aptitud;
        this.userId = this.currentUser.user_id;
      }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // Directive
    @ViewChild(RossPerfectScrollbarDirective, { static: true })
    set directive(theDirective: RossPerfectScrollbarDirective) {
        if (!theDirective) {
            return;
        }

        this._rossPerfectScrollbar = theDirective;

        // Update the scrollbar on collapsable item toggle
        this._rossNavigationService.onItemCollapseToggled
            .pipe(
                delay(500),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this._rossPerfectScrollbar.update();
            });

        // Scroll to the active item position
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                take(1)
            )
            .subscribe(() => {
                setTimeout(() => {
                    const activeNavItem: any = document.querySelector('navbar .nav-link.active');

                    if (activeNavItem) {
                        const activeItemOffsetTop = activeNavItem.offsetTop,
                            activeItemOffsetParentTop = activeNavItem.offsetParent.offsetTop,
                            scrollDistance = activeItemOffsetTop - activeItemOffsetParentTop - (48 * 3) - 168;

                        this._rossPerfectScrollbar.scrollToTop(scrollDistance);
                    }
                });
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Close sidebar on navigation
        this._router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                if (this._rossSidebarService.getSidebar('navbar')) {
                    this._rossSidebarService.getSidebar('navbar').close();
                }
            });

        // Subscribe to the config changes
        this._rossConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.rossConfig = config;
            });

        // Get current navigation
        this._rossNavigationService.onNavigationChanged
            .pipe(
                filter(value => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._rossNavigationService.getCurrentNavigation();
            });

        // Load profile image
        // this.loadProfileImage();
        this.profileImageService.profileImageUrl$.subscribe((url) => {
            this.profileImageUrl = url;
          });
        
         
          this.loadProfileImage(this.userId);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Load profile image
     */
    loadProfileImage(userId: number): void {
      if (!userId) return;
    
      this.profileImageService.getProfileImage(userId).subscribe({
        next: (response) => this.handleProfileImage(response),
        error: () => this.setDefaultProfileImage(),
      });
    }
    
    private handleProfileImage(response: Blob): void {
      if (response.size === 0) {
        this.setDefaultProfileImage();
        return;
      }
    
      const reader = new FileReader();
      reader.onloadend = () => this.profileImageService.setProfileImageUrl(reader.result as string);
      reader.readAsDataURL(response);
    }
    
    private setDefaultProfileImage(): void {
      this.profileImageService.setProfileImageUrl('assets/img/user.svg');
    }

    /**
     * Toggle sidebar opened status
     */
    toggleSidebarOpened(): void {
        this._rossSidebarService.getSidebar('navbar').toggleOpen();
    }

    /**
     * Toggle sidebar folded status
     */
    toggleSidebarFolded(): void {
        this._rossSidebarService.getSidebar('navbar').toggleFold();
    }

    /**
     * Handle file selection
     */
    openProfileImageDialog(): void {
        const dialogRef = this.dialog.open(ProfileImageDialogComponent, {
          width: '400px',
          data: { 
            profileImageUrl: this.profileImageUrl,
            userId: this.userId 
          }
        });
      
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.profileImageUrl = result.profileImageUrl;
            
          }
        });
      }
}